import { Route, Routes } from "react-router";
import { NotFound } from "../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../common/constants";
import { TopAgentType } from "../../common/enums";
import { Permission } from "../../common/security/enums";
import PageWithPermission from "../auth/components/PageWithPermission";
import { BusinessCoefficientsContainer } from "./containers/BusinessCoefficientsContainer";
import { InvestCombinationsContainer } from "./containers/InvestCombinationsContainer";
import { useHasInvestCombinationsAccess } from "./hooks";
import { OVERVIEWS_ROUTE_PATHS } from "./paths";

export const OverviewsRoutes = () => {
  const hasInvestCombinationsAccess = useHasInvestCombinationsAccess();

  return (
    <Routes>
      <Route
        path={OVERVIEWS_ROUTE_PATHS.businessCoefficients.path}
        element={
          <PageWithPermission
            component={<BusinessCoefficientsContainer />}
            permissions={[Permission.AGENT_COMMISSIONS]}
            allowedTopAgents={[TopAgentType.PLUS]}
          />
        }
      />

      <Route
        path={OVERVIEWS_ROUTE_PATHS.investCombinations.path}
        element={
          hasInvestCombinationsAccess ? (
            <PageWithPermission
              component={<InvestCombinationsContainer />}
              permissions={[]}
              allowedTopAgents={[TopAgentType.PLUS]}
            />
          ) : (
            <NotFound />
          )
        }
      />

      <Route path={WILDCARD_ROUTE} element={<NotFound />} />
    </Routes>
  );
};
